export const notificationTimeout = 15000;